import React from 'react';
import { StyleSheet, Text, View } from 'react-native';
import { useMediaQuery } from 'react-responsive';

import { useConsumerQuery } from 'apollo/queries/autogenerate/hooks';
import Button from 'shared/modules/common/components/atoms/Button';

type Props = {
  onEditButtonPress: () => void;
};

const UserEmail = (props: Props) => {
  const { data } = useConsumerQuery({ fetchPolicy: 'cache-only' });
  const isHugeScreen = useMediaQuery({ minWidth: 1024 });

  return (
    <>
      <View style={style.row}>
        <View style={style.detailRow}>
          <View style={style.titleContainer}>
            <Text style={style.descriptionText}>登録中のメールアドレス</Text>
          </View>
          {isHugeScreen && (
            <View style={style.emailContainer}>
              <Text numberOfLines={2} style={style.detailText}>
                {data?.consumer.email}
              </Text>
            </View>
          )}
        </View>
        <Button
          title="編集"
          variant="outlined"
          titleStyle={style.buttonTitle}
          onPress={props.onEditButtonPress}
          style={style.editButton}
          id="edit-user-email-button"
        />
      </View>
      {!isHugeScreen && (
        <Text style={style.detailTextMobile}>{data?.consumer.email}</Text>
      )}
    </>
  );
};

const style = StyleSheet.create({
  descriptionText: {
    fontSize: 12,
    width: 176,
  },
  detailText: {
    fontSize: 12,
    fontWeight: 'bold',
  },
  row: {
    flexDirection: 'row',
    alignItems: 'center',
  },
  editButton: {
    height: 32,
    width: 88,
  },
  detailRow: {
    flex: 1,
    flexDirection: 'row',
  },
  detailTextMobile: {
    fontSize: 12,
    fontWeight: 'bold',
    maxWidth: 192,
  },
  emailContainer: {
    flex: 2,
    alignItems: 'flex-start',
    marginHorizontal: 16,
  },
  titleContainer: {
    flex: 1,
  },
  buttonTitle: {
    fontSize: 12,
  },
});

export default UserEmail;
